import React from "react"
import "twin.macro"
const fill = [
  {
    name: "Your Name (required)",
  },
  {
    name: "Your Email (required)",
  },
  {
    name: "Subject",
  },
]
const Contact = () => {
  return (
    <>
      {/* middle side */}
      <div tw="bg-white max-w-3xl md:col-span-5 shadow-2xl">
        <h1 tw="mt-3.5 ml-4 text-2xl font-semibold pt-8 pl-6">Contact Me</h1>
        <div tw="p-10">
          <h1 tw="mt-3.5 ml-4 text-xl font-semibold ">
            Fell free to contact me in case of any question
          </h1>
          <div tw="p-6">
            {fill.map((item, index) => (
              <div tw="mb-4">
                <label tw="block text-gray-900 text-sm font-light mb-2">
                  {item.name}
                </label>
                <input tw="bg-gray-100 shadow  border rounded w-full py-2 px-3 text-gray-700 leading-tight" />
              </div>
            ))}
            <div tw="mb-4">
              <label tw="block text-gray-900 text-sm font-light mb-2">
                Your Message
              </label>
              <textarea tw="w-full px-3 py-2 bg-gray-100 shadow border rounded-lg "></textarea>
            </div>
            <button tw="bg-blue-300  hover:shadow-lg  text-white font-bold py-2 px-4 rounded-full">
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
export default Contact
